

export const useStyles = MUITheme => ({
  messageBox: {
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 4,
    padding: "13px 20px",
    marginTop: "20px ",
    color: MUITheme.palette.text.primary,
    fontSize: "14px !important",
    lineHeight: "20px",
    letterSpacing: 0.25,
    textAlign: "left",
    wordBreak: "break-word",
    '&.text-center':{
      textAlign:'center'
    },
    '&.no-border':{
      border:'none',
      borderRadius:0
    },
    '&.m-0':{
      margin:0
    },
    '&.p-4':{
      padding:4
    },
    '&.p-6':{
      padding:6
    },
    '&.p-10':{
      padding:10
    },
    '& .icon':{
      margin:4,
      '& svg':{
        width:'1rem',
        height:'1rem',
        verticalAlign:'middle',
        color:'rgb(2, 136, 209)'
      }
    }
  },
  error: {
    borderColor: '#E67381',
    backgroundColor: "#FDE5E8",
    '& .icon svg':{
      color:'#E67381'
    }
  },
  success: {
    borderColor: '#00C48C',
    backgroundColor: '#E7FFF8',
    '& .icon svg':{
      color:'#00C48C'
    },
  },
  warning: {
    borderColor: MUITheme.palette.border.warning,
    backgroundColor: MUITheme.palette.background.warning,
    color:MUITheme.palette.text.warning,
    "& a": {
      color: MUITheme.palette.infoBoxLink,
      fontWeight: 600,
    },
    '& .icon svg':{
      color:MUITheme.palette.border.warning
    },
  },
  info: {
    borderColor: MUITheme.palette.primary.main,
    backgroundColor: MUITheme.palette.background.infoBox,
    "& a": {
      color: MUITheme.palette.infoBoxLink,
      fontWeight: 600,
    },
    '& .message':{
      color:'var(--sm_primary)'
    }
  },
});
